<template>
  <div class="">
    <BaseTemp>
      <template v-slot:content>
        <Impressum />
      </template>
    </BaseTemp>
  </div>
</template>


<style lang="sass">

</style>

<script>
import Impressum from "@/components/Impressum.vue";
import BaseTemp from "@/components/BaseTemp.vue";

export default {
  name: "ImpressumComp",
  components: {BaseTemp,Impressum}
};
</script>